// Liste des villes principales par pays
export const MAJOR_CITIES: { [key: string]: string[] } = {
  'aus': [
    'Adelaide',
    'Albany',
    'Alice Springs',
    'Ballarat',
    'Bathurst',
    'Bendigo',
    'Brisbane',
    'Broome',
    'Bundaberg',
    'Cairns',
    'Canberra',
    'Coffs Harbour',
    'Darwin',
    'Geelong',
    'Geraldton',
    'Gold Coast',
    'Hobart',
    'Launceston',
    'Mackay',
    'Mildura',
    'Melbourne',
    'Newcastle',
    'Noosa',
    'Perth',
    'Port Macquarie',
    'Rockhampton',
    'Sunshine Coast',
    'Sydney',
    'Toowoomba',
    'Townsville',
    'Wagga Wagga',
    'Whitsundays',
    'Wollongong'
  ],
  'nz': [
    'Auckland',
    'Blenheim',
    'Cambridge',
    'Christchurch',
    'Dunedin',
    'Franz Josef',
    'Gisborne',
    'Greymouth',
    'Hamilton',
    'Invercargill',
    'Kaikoura',
    'Masterton',
    'Napier-Hastings',
    'Nelson',
    'New Plymouth',
    'Oamaru',
    'Palmerston North',
    'Paihia',
    'Picton',
    'Queenstown',
    'Rotorua',
    'Taupo',
    'Tauranga',
    'Te Anau',
    'Timaru',
    'Wanaka',
    'Wellington',
    'Westport',
    'Whakatane',
    'Whanganui',
    'Whangarei'
  ],
  'ca': [
    'Banff',
    'Calgary',
    'Charlottetown',
    'Edmonton',
    'Fredericton',
    'Halifax',
    'Hamilton',
    'Jasper',
    'Kamloops',
    'Kelowna',
    'Kingston',
    'Kitchener',
    'Lethbridge',
    'London',
    'Moncton',
    'Montreal',
    'Nanaimo',
    'Niagara Falls',
    'Ottawa',
    'Quebec City',
    'Red Deer',
    'Regina',
    'Saskatoon',
    'Sherbrooke',
    'St. John\'s',
    'Sudbury',
    'Thunder Bay',
    'Toronto',
    'Trois-Rivieres',
    'Vancouver',
    'Victoria',
    'Whistler',
    'Whitehorse',
    'Windsor',
    'Winnipeg',
    'Yellowknife'
  ],
  'jpn': [
    'Fukuoka',
    'Hakone',
    'Himeji',
    'Hiroshima',
    'Kagoshima',
    'Kamakura',
    'Kanazawa',
    'Kawasaki',
    'Kobe',
    'Kumamoto',
    'Kyoto',
    'Matsumoto',
    'Nagano',
    'Nagasaki',
    'Nagoya',
    'Nara',
    'Nikko',
    'Niigata',
    'Okinawa',
    'Okayama',
    'Osaka',
    'Saitama',
    'Sapporo',
    'Sendai',
    'Shizuoka',
    'Takayama',
    'Tokyo',
    'Toyama',
    'Tsukuba',
    'Yokohama'
  ],
  'kor': [
    'Andong',
    'Busan',
    'Changwon',
    'Cheongju',
    'Chuncheon',
    'Daegu',
    'Daejeon',
    'Gangneung',
    'Gimhae',
    'Goyang',
    'Gunsan',
    'Gwangju',
    'Gyeongju',
    'Incheon',
    'Jecheon',
    'Jeju',
    'Jeonju',
    'Jinju',
    'Mokpo',
    'Namhae',
    'Pohang',
    'Pyeongtaek',
    'Seogwipo',
    'Seoul',
    'Sokcho',
    'Suncheon',
    'Suwon',
    'Tongyeong',
    'Ulsan',
    'Yeosu'
  ],
  'twn': [
    'Alishan',
    'Changhua',
    'Chiayi',
    'Hsinchu',
    'Hualien',
    'Jiufen',
    'Kaohsiung',
    'Keelung',
    'Kenting',
    'Lukang',
    'Miaoli',
    'Nantou',
    'New Taipei',
    'Penghu',
    'Pingtung',
    'Sun Moon Lake',
    'Taichung',
    'Tainan',
    'Taipei',
    'Taitung',
    'Taoyuan',
    'Tamsui',
    'Wulai',
    'Yilan',
    'Yunlin',
    'Zhubei',
    'Beitou',
    'Jiaoxi',
    'Sanxia',
    'Shifen'
  ],
  'arg': [
    'Bahia Blanca',
    'Bariloche',
    'Buenos Aires',
    'Comodoro Rivadavia',
    'Cordoba',
    'Corrientes',
    'El Bolson',
    'El Calafate',
    'Formosa',
    'Iguazu',
    'Jujuy',
    'La Plata',
    'Mar del Plata',
    'Mendoza',
    'Neuquen',
    'Parana',
    'Posadas',
    'Puerto Madryn',
    'Resistencia',
    'Rio Gallegos',
    'Rosario',
    'Salta',
    'San Carlos de Bariloche',
    'San Juan',
    'San Luis',
    'San Martin de los Andes',
    'San Miguel de Tucuman',
    'San Rafael',
    'Santa Fe',
    'Ushuaia',
    'Villa La Angostura',
    'Villa Carlos Paz'
  ],
  'chl': [
    'Antofagasta',
    'Arica',
    'Calama',
    'Castro',
    'Chillan',
    'Concepcion',
    'Copiapo',
    'Coquimbo',
    'Coyhaique',
    'Iquique',
    'La Serena',
    'Los Angeles',
    'Osorno',
    'Pucón',
    'Puerto Montt',
    'Puerto Natales',
    'Puerto Varas',
    'Punta Arenas',
    'Rancagua',
    'San Antonio',
    'San Fernando',
    'San Pedro de Atacama',
    'Santiago',
    'Talca',
    'Temuco',
    'Valdivia',
    'Valparaiso',
    'Villa Alemana',
    'Vina del Mar',
    'Villarrica'
  ],
  'col': [
    'Armenia',
    'Barranquilla',
    'Bogota',
    'Bucaramanga',
    'Cali',
    'Cartagena',
    'Cucuta',
    'Florencia',
    'Ibague',
    'Leticia',
    'Manizales',
    'Medellin',
    'Monteria',
    'Neiva',
    'Pasto',
    'Pereira',
    'Popayan',
    'Riohacha',
    'Salento',
    'San Andres',
    'San Gil',
    'Santa Marta',
    'Sincelejo',
    'Sogamoso',
    'Taganga',
    'Tunja',
    'Valledupar',
    'Villa de Leyva',
    'Villavicencio',
    'Zipaquira'
  ],
  'mex': [
    'Acapulco',
    'Aguascalientes',
    'Cabo San Lucas',
    'Campeche',
    'Cancun',
    'Chihuahua',
    'Durango',
    'Guadalajara',
    'Guanajuato',
    'Juarez',
    'La Paz',
    'Leon',
    'Merida',
    'Mexico City',
    'Monterrey',
    'Morelia',
    'Oaxaca',
    'Pachuca',
    'Playa del Carmen',
    'Puebla',
    'Puerto Vallarta',
    'Queretaro',
    'San Cristobal de las Casas',
    'San Luis Potosi',
    'San Miguel de Allende',
    'Tijuana',
    'Toluca',
    'Torreon',
    'Tulum',
    'Tuxtla Gutierrez',
    'Veracruz',
    'Villahermosa',
    'Zacatecas'
  ],
  'per': [
    'Arequipa',
    'Ayacucho',
    'Cajamarca',
    'Chachapoyas',
    'Chimbote',
    'Chiclayo',
    'Cusco',
    'Huancayo',
    'Huaraz',
    'Ica',
    'Iquitos',
    'Juliaca',
    'Lima',
    'Mancora',
    'Nazca',
    'Ollantaytambo',
    'Paracas',
    'Piura',
    'Pucallpa',
    'Puerto Maldonado',
    'Puno',
    'Sullana',
    'Tacna',
    'Tarapoto',
    'Trujillo',
    'Tumbes',
    'Aguas Calientes',
    'Huancavelica',
    'Lambayeque',
    'Moquegua'
  ],
  'uru': [
    'Artigas',
    'Atlantida',
    'Canelones',
    'Carmelo',
    'Chuy',
    'Colonia del Sacramento',
    'Dolores',
    'Durazno',
    'Florida',
    'Fray Bentos',
    'Jose Ignacio',
    'La Paloma',
    'La Pedrera',
    'Las Piedras',
    'Maldonado',
    'Melo',
    'Mercedes',
    'Minas',
    'Montevideo',
    'Paysandu',
    'Piriapolis',
    'Punta del Diablo',
    'Punta del Este',
    'Rivera',
    'Rocha',
    'Salto',
    'San Jose',
    'Tacuarembo',
    'Treinta y Tres',
    'Trinidad'
  ],
  'bra': [
    'Belem',
    'Belo Horizonte',
    'Brasilia',
    'Buzios',
    'Campinas',
    'Campo Grande',
    'Curitiba',
    'Florianopolis',
    'Fortaleza',
    'Foz do Iguacu',
    'Goiania',
    'Gramado',
    'Ilheus',
    'Joao Pessoa',
    'Macapa',
    'Maceio',
    'Manaus',
    'Natal',
    'Niteroi',
    'Olinda',
    'Ouro Preto',
    'Paraty',
    'Porto Alegre',
    'Porto Seguro',
    'Recife',
    'Rio de Janeiro',
    'Salvador',
    'Santos',
    'Sao Luis',
    'Sao Paulo',
    'Ubatuba',
    'Vitoria'
  ],
  'hkg': [
    'Aberdeen',
    'Causeway Bay',
    'Central',
    'Cheung Chau',
    'Discovery Bay',
    'Hong Kong',
    'Jordan',
    'Kennedy Town',
    'Kowloon',
    'Kowloon City',
    'Kwun Tong',
    'Lamma Island',
    'Lantau Island',
    'Mong Kok',
    'North Point',
    'Peng Chau',
    'Repulse Bay',
    'Sai Kung',
    'Sha Tin',
    'Sham Shui Po',
    'Sheung Wan',
    'Stanley',
    'Tai O',
    'Tai Po',
    'Tin Shui Wai',
    'Tseung Kwan O',
    'Tsim Sha Tsui',
    'Tsuen Wan',
    'Tuen Mun',
    'Wan Chai',
    'Yuen Long'
  ],
  'fra': [
    'Aix-en-Provence',
    'Ajaccio',
    'Amiens',
    'Angers',
    'Annecy',
    'Avignon',
    'Bayonne',
    'Besancon',
    'Biarritz',
    'Bordeaux',
    'Brest',
    'Caen',
    'Cannes',
    'Clermont-Ferrand',
    'Colmar',
    'Dijon',
    'Grenoble',
    'La Rochelle',
    'Le Mans',
    'Lille',
    'Limoges',
    'Lyon',
    'Marseille',
    'Metz',
    'Montpellier',
    'Nantes',
    'Nice',
    'Nimes',
    'Orleans',
    'Paris',
    'Pau',
    'Perpignan',
    'Poitiers',
    'Reims',
    'Rennes',
    'Rouen',
    'Saint-Etienne',
    'Strasbourg',
    'Toulon',
    'Toulouse',
    'Tours',
    'Valence'
  ],
  'ecu': [
    'Ambato',
    'Atacames',
    'Banos',
    'Coca',
    'Cotacachi',
    'Cuenca',
    'Esmeraldas',
    'Guaranda',
    'Guayaquil',
    'Ibarra',
    'Latacunga',
    'Loja',
    'Macas',
    'Machala',
    'Manta',
    'Mindo',
    'Montanita',
    'Otavalo',
    'Portoviejo',
    'Puerto Ayora',
    'Puerto Lopez',
    'Puyo',
    'Quito',
    'Riobamba',
    'Salinas',
    'Santo Domingo',
    'Shell',
    'Tena',
    'Tulcan',
    'Vilcabamba'
  ]
};

export const budgetCountries: Country[] = [
  {
    code: 'aus',
    name: 'Australie',
    flag: '🇦🇺',
    image: 'https://images.unsplash.com/photo-1506973035872-a4ec16b8e8d9?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'nz',
    name: 'Nouvelle-Zélande',
    flag: '🇳🇿',
    image: 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'ca',
    name: 'Canada',
    flag: '🇨🇦',
    image: 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?q=80&w=2611&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'jpn',
    name: 'Japon',
    flag: '🇯🇵',
    image: 'https://images.unsplash.com/photo-1480796927426-f609979314bd?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'kor',
    name: 'Corée du Sud',
    flag: '🇰🇷',
    image: 'https://images.unsplash.com/photo-1517154421773-0529f29ea451?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'twn',
    name: 'Taïwan',
    flag: '🇹🇼',
    image: 'https://plus.unsplash.com/premium_photo-1661951189203-12decb9d7f8e?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'arg',
    name: 'Argentine',
    flag: '🇦🇷',
    image: 'https://images.unsplash.com/photo-1612294037637-ec328d0e075e?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'chl',
    name: 'Chili',
    flag: '🇨🇱',
    image: 'https://images.unsplash.com/photo-1546800273-4d63ff843853?q=80&w=2574&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'col',
    name: 'Colombie',
    flag: '🇨🇴',
    image: 'https://images.unsplash.com/photo-1576018753502-1a55b66cc44a?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'mex',
    name: 'Mexique',
    flag: '🇲🇽',
    image: 'https://images.unsplash.com/photo-1518105779142-d975f22f1b0a?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'per',
    name: 'Pérou',
    flag: '🇵🇪',
    image: 'https://images.unsplash.com/photo-1526392060635-9d6019884377?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'uru',
    name: 'Uruguay',
    flag: '🇺🇾',
    image: 'https://images.unsplash.com/photo-1624416254374-b471bfcaac81?q=80&w=2670&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'bra',
    name: 'Brésil',
    flag: '🇧🇷',
    image: 'https://images.unsplash.com/photo-1483729558449-99ef09a8c325?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'hkg',
    name: 'Hong Kong',
    flag: '🇭🇰',
    image: 'https://images.unsplash.com/photo-1536599018102-9f803c140fc1?auto=format&fit=crop&q=80&w=800',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'fra',
    name: 'France',
    flag: '🇫🇷',
    image: 'https://images.unsplash.com/photo-1502602898657-3e91760cbb34?q=80&w=2673&auto=format&fit=crop&ixlib=rb-4.0.3',
    hasList: false,
    defaultTasks: []
  },
  {
    code: 'ecu',
    name: 'Équateur',
    flag: '🇪🇨',
    image: 'https://images.unsplash.com/photo-1504457047772-27faf1c00561?q=80&w=2670&auto=format&fit=crop',
    hasList: false,
    defaultTasks: []
  }
].sort((a, b) => a.name.localeCompare(b.name, 'fr', { sensitivity: 'base' }));